import Vue from "vue";
import Vuex from "vuex";
// import axios from 'axios'
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    cambios: false,
    navbarVerticalEstado: false,
    categoriaPlat: "",
    EstadoPlatPersonal: false,
    EstadoPlatOperacional: false,
    EstadoDeBotones: false,
    EstadoPostulacion:false,
    EstadoDePlaformaPerfil:0
  },
  getters: {
    Cambios(state) {
      return state.cambios;
    },

    NavbarVertical(state) {
      return state.navbarVerticalEstado;
    },

    Plataforma(state) {
      return state.categoriaPlat;
    },

    EstadoPlataformaPersonal(state) {
      return state.EstadoPlatPersonal;
    },

    EstadoPlataformaOperacional(state) {
      return state.EstadoPlatOperacional;
    },

    EstadoBotonUsuarios(state) {
      return state.EstadoDeBotones;
    },

    EstadoBotonPostulacion(state){
      return state.EstadoPostulacion;
    },

    EstadoPlaformaPerfil(state){
      return state.EstadoDePlaformaPerfil;
    }
  },
  mutations: {
    llenarCambios(state, data) {
      state.cambios = data;
    },

    llenarNavbar(state, data) {
      state.navbarVerticalEstado = data;
    },

    llevarPlataforma(state, data) {
      state.categoriaPlat = data;
    },

    LlenarEstadoPersonal(state, data) {
      state.EstadoPlatPersonal = data;
    },

    LlenarEstadoOperacional(state, data) {
      state.EstadoPlatOperacional = data;
    },

    LlenaEstadoDeBotones(state, data) {
      state.EstadoDeBotones = data;
    },
    
    llenarEstadoPostulacion(state,data){
      state.EstadoPostulacion = data
    },

    llenarEstadoPlataforma(state, data){
      state.EstadoDePlaformaPerfil = data
    }
  },

  actions: {
    CambiosEstado({ commit }, cambio) {
      commit("llenarCambios", cambio);
    },

    CambioNavbar({ commit }, estado) {
      commit("llenarNavbar", estado);
    },

    EstadoPersonal({ commit}, {estado, estadoPostulacion}) {
      commit("LlenarEstadoPersonal", estado);
      commit("LlenarEstadoOperacional", !estado);
      commit("LlenaEstadoDeBotones", true);
      commit('llenarEstadoPostulacion' ,false);
      localStorage.setItem('guardarEstadoPerfilPostulante' , estadoPostulacion)
      commit('llenarEstadoPlataforma', estadoPostulacion)


    },

    EstadoOperacional({ commit }, estado) {
      commit("LlenarEstadoOperacional", estado);
      commit("LlenarEstadoPersonal", !estado);
      commit("LlenaEstadoDeBotones", true);
      commit('llenarEstadoPostulacion' ,false);

    },

    EstadoDeBotonUsuarios({ commit ,state }, estado) {
      commit("LlenaEstadoDeBotones", estado);
      commit("LlenarEstadoOperacional", false);
      commit("LlenarEstadoPersonal", false);
      commit('llenarEstadoPostulacion' ,false);
      localStorage.setItem('guardarEstadoPerfilPostulante' , 0)
      console.log(state.EstadoDePlaformaPerfil); // ✅ CORRECTO
    },

    EstadoBotonPostulacion ({commit}, estado){
      commit('llenarEstadoPostulacion' ,estado);
      commit("LlenarEstadoOperacional", false);
      commit("LlenarEstadoPersonal", false);
      commit("LlenaEstadoDeBotones", true);

    },

    EstadoPlataformaPersona({commit}, estado){
      commit('llenarEstadoPlataforma', estado)
      console.log(estado)
    },

    PlataformaCategoria({ commit }) {
      commit("llevarPlataforma", localStorage.getItem("catPlataforma"));

      console.log("tu plataforma es: " + localStorage.getItem("catPlataforma"));
    },
  },
  modules: {},
};
